export default __webpack_public_path__ + "static/media/studenthelper_slide3.a72d6462.png";